<template>
  <div class="pa-10">
    <PreferredOJTLocationDataTable />
  </div>
</template>

<script>
import PreferredOJTLocationDataTable from "@/components/Utils/PreferredOJTLocationDataTable.vue";
export default {
  components: {
    PreferredOJTLocationDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
